<template>
	<div
		class="floating-panels-stack"
		:class="{ 'floating-panels-stack--with-tasks': hasTasks }"
	>
		<MinimizedFileManager embedded />
		<GlobalFloatingButtons
			v-if="showGlobalFloatingButtons"
			embedded
		/>
	</div>
</template>

<script>
import GlobalFloatingButtons from './GlobalFloatingButtons'
import MinimizedFileManager from '@/components/Globals/Helpers/MinimizedFileManager'

export default {
	name: 'FloatingPanelsStack',
	components: { GlobalFloatingButtons, MinimizedFileManager },
	props: {
		showGlobalFloatingButtons: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		hasTasks() {
			const tasks = this.$store.globalStore.state.openTasksHandler
			return Array.isArray(tasks) && tasks.length > 0
		}
	}
}
</script>

<style scoped>
.floating-panels-stack {
	position: fixed;
	bottom: 10px;
	right: 10px;
	z-index: 9998;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 10px;
	pointer-events: auto;
}

.floating-panels-stack--with-tasks {
	bottom: 60px;
}

@media (max-width: 420px) {
	.floating-panels-stack {
		bottom: 12px;
		left: 12px;
		right: auto;
		align-items: flex-start;
	}

	.floating-panels-stack--with-tasks {
		bottom: 72px;
	}
}
</style>
